import NumberCard from "./NumberCard";

import BlogCard from "./BlogCard";

import InfoCard from "./InfoCard";
import TotalNumbersCard from "./TotalNumbersCard";
import BlogCardSkeleton from "./BlogCardSkeleton";
import NumberCardSkeleton from "./NumberCardSkeleton";

export { NumberCard, BlogCard, InfoCard, TotalNumbersCard, BlogCardSkeleton, NumberCardSkeleton };
